<template>
  <div class="user-item-sku-bookmark-edit-order-page__container">
    <div class="feedback">
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError
          v-if="showableErrorFeedback"
          :message="feedbackErrorMessage"
        />
      </transition>
    </div>
    <div
      v-if="!isApp"
      class="user-item-sku-bookmark-edit-order-page__page-header-area"
    >
      <PageHeadlineTitle title="ブックマークしたギフトの並べ替え" />
    </div>
    <div class="user-item-sku-bookmark-edit-order-page__main-area">
      <div class="user-item-sku-bookmark-edit-order-page__main-content">
        <div
          v-if="showBoxListAlert"
          class="user-item-sku-bookmark-edit-order-page__box-list-area"
        >
          <ul
            class="box-list--alert user-item-sku-bookmark-edit-order-page__box-list"
          >
            <li v-if="hasValidationError">
              お手数ですが画面を読み込み直して再度お試しください
            </li>
          </ul>
        </div>
        <ul class="user-item-sku-bookmark-edit-order-page__caption-ul">
          <li class="user-item-sku-bookmark-edit-order-page__caption-li">
            ブックマークしたギフトの並び順の変更ができます
          </li>
          <li class="user-item-sku-bookmark-edit-order-page__caption-li">
            移動したいギフトを長押ししてお好きな場所に差し込むこともできます
          </li>
          <li class="user-item-sku-bookmark-edit-order-page__caption-li">
            商品内容が変更となる場合がございますので、定期的に見直しをおすすめします。
          </li>
        </ul>
        <div class="user-item-sku-bookmark-edit-order-page__form-area">
          <SmallLoading
            v-if="isBookmarksLoading"
            class="user-item-sku-bookmark-edit-order-page__loading"
          />
          <div v-else>
            <draggable
              v-model="bookmarks"
              item-key="id"
              :delay="LONG_PRESS_SEC"
              @end="onEndDrag"
            >
              <template #item="{ element, index }">
                <BookmarkItemSkuForEditOrder
                  :key="element.id"
                  :user-item-sku-bookmark-id="element.id"
                  :image-url="element.imageUrl"
                  :brand-name="element.brandName"
                  :item-name="element.itemName"
                  :item-sku-name="element.itemSkuName"
                  :item-id="element.itemId"
                  :item-sku-id="element.itemSkuId"
                  :out-of-stock="element.outOfStock"
                  :is-up-button-disabled="index === 0"
                  :is-down-button-disabled="index === bookmarks.length - 1"
                  @click-up="onClickUp(index)"
                  @click-down="onClickDown(index)"
                  @click-top="onClickTop(index)"
                  @click-bottom="onClickBottom(index)"
                />
              </template>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <div class="user-item-sku-bookmark-edit-order-page__submit-area">
      <div class="user-item-sku-bookmark-edit-order-page__submit-buttons">
        <ButtonSecondary
          text="キャンセル"
          class="user-item-sku-bookmark-edit-order-page__cancel-button"
          :disabled="isSubmitButtonDisable || null"
          @click-secondary-button="clickCancelButton"
        />
        <ButtonPrimary
          text="変更を保存"
          class="user-item-sku-bookmark-edit-order-page__submit-button"
          :disabled="isSubmitButtonDisable || null"
          @click-primary-button="clickSubmitButton"
        />
      </div>
    </div>
    <TextModalWithSecondary
      v-if="showCancelDialog"
      title-text="変更内容が保存されていません"
      caption-text=""
      primary-button-text="編集を続ける"
      secondary-button-text="保存せずに前の画面に戻る"
      cancel-button-text="閉じる"
      @clicked-modal-cover="closeCancelModal"
      @clicked-primary="closeCancelModal"
      @clicked-secondary="backToBookmarkIndexPage"
      @clicked-cancel="closeCancelModal"
    />
  </div>
</template>
<script>
import FeedbackError from '../../../atoms/feedbacks/feedback-error.vue'
import PageHeadlineTitle from '../../../atoms/headlines/PageHeadlineTitle.vue'
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'
import BookmarkItemSkuForEditOrder from '../../../molecules/item_sku_bookmark/BookmarkItemSkuForEditOrder.vue'
import ButtonSecondary from '../../../molecules/buttons/ButtonSecondary.vue'
import ButtonPrimary from '../../../molecules/buttons/ButtonPrimary.vue'
import TextModalWithSecondary from '../../../molecules/modals/with_secondary/text-modal-with-secondary.vue'
import { draggableConstants } from '../../../../constants/draggableConstants'

import axios from 'axios'
import { cloneDeep, isEqual } from 'lodash'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
    FeedbackError,
    PageHeadlineTitle,
    SmallLoading,
    BookmarkItemSkuForEditOrder,
    ButtonSecondary,
    ButtonPrimary,
    TextModalWithSecondary
  },
  props: {
    isApp: {
      type: Boolean,
      required: true
    },
    bookmarkIndexPath: {
      type: String,
      required: true
    }
  },
  setup() {
    const LONG_PRESS_SEC = draggableConstants.LONG_PRESS_SEC
    return { LONG_PRESS_SEC }
  },
  data() {
    return {
      showableErrorFeedback: false,
      feedbackErrorMessage: '',
      isBookmarksLoading: true,
      bookmarks: [],
      initialBookmarks: [],
      hasValidationError: false,
      isSubmitButtonDisable: false,
      showCancelDialog: false
    }
  },
  computed: {
    showBoxListAlert() {
      return this.hasValidationError
    },
    changeAnyValue() {
      return !isEqual(this.initialBookmarks, this.bookmarks)
    }
  },
  mounted() {
    this.getBookmarks()
  },
  methods: {
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    showError(error) {
      this.showableErrorFeedback = true
      this.errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
    },
    async getBookmarks() {
      this.isBookmarksLoading = true
      this.isSubmitButtonDisable = true
      try {
        const res = await axios.get('/api/v1/users/@me/item_sku_bookmarks')
        this.bookmarks = res.data.data.map(bookmark => {
          // TODO: dummyimage を正式が画像に置換する
          const itemSkuImageUrl = bookmark.attributes.imageUrl
            ? bookmark.attributes.imageUrl
            : 'https://dummyimage.com/90x90/ccc/999.png&text=Not+Found'
          return {
            id: bookmark.attributes.id,
            imageUrl: itemSkuImageUrl,
            itemSkuId: bookmark.attributes.itemSkuId,
            itemSkuName: bookmark.attributes.itemSkuName,
            itemId: bookmark.attributes.itemId,
            itemName: bookmark.attributes.itemName,
            brandName: bookmark.attributes.brandName,
            outOfStock: bookmark.attributes.outOfStock,
            linkUrl: bookmark.attributes.linkUrl
          }
        })

        this.initialBookmarks = cloneDeep(this.bookmarks)
        this.isBookmarksLoading = false
        this.isSubmitButtonDisable = false
      } catch (error) {
        this.isBookmarksLoading = false
        this.showableErrorFeedback = true
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.feedbackErrorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    pushRearrangeDataLayer(how) {
      // TODO: アプリ側でブックマーク機能アプリ化のリリース後に、強制アップデートをした場合、WEBのみのプログラムに修正
      if (!this.isApp) {
        dataLayer.push({
          event: 'click_bkmk_list_edit_order__rearrange',
          how: how
        })
      } else {
        logEvent('click_bkmk_list_edit_order__rearrange', {
          how: how
        })
      }
    },
    onEndDrag() {
      this.pushRearrangeDataLayer('drag')
    },
    onClickUp(index) {
      if (index === 0) return

      this.pushRearrangeDataLayer('up')
      this.moveBookmarkAt(index, index - 1)
    },
    onClickDown(index) {
      if (index === this.bookmarks.length - 1) return
      this.pushRearrangeDataLayer('down')
      this.moveBookmarkAt(index, index + 1)
    },
    onClickTop(index) {
      if (index === 0) return

      this.pushRearrangeDataLayer('top')
      this.moveBookmarkAt(index, 0)
    },
    onClickBottom(index) {
      if (index === this.bookmarks.length - 1) return
      this.pushRearrangeDataLayer('bottom')
      this.moveBookmarkAt(index, this.bookmarks.length - 1)
    },
    moveBookmarkAt(index, at) {
      if (index === at) return
      if (index < 0 || index > this.bookmarks.length - 1) return
      if (at < 0 || at > this.bookmarks.length - 1) return

      const value = this.bookmarks[index]

      this.bookmarks.splice(index, 1)
      this.bookmarks.splice(at, 0, value)
    },
    clickCancelButton() {
      this.isSubmitButtonDisable = true
      if (this.changeAnyValue) {
        this.showCancelDialog = true
      } else {
        this.backToBookmarkIndexPage()
      }
    },
    backToBookmarkIndexPage() {
      window.location = this.bookmarkIndexPath
    },
    closeCancelModal() {
      this.showCancelDialog = false
      this.isSubmitButtonDisable = false
    },
    async clickSubmitButton() {
      this.isSubmitButtonDisable = true
      // TODO: アプリ側でブックマーク機能アプリ化のリリース後に、強制アップデートをした場合、WEBのみのプログラムに修正
      if (!this.isApp) {
        dataLayer.push({
          event: 'click_bkmk_list_edit_order__save'
        })
      } else {
        logEvent('click_bkmk_list_edit_order__save')
      }

      try {
        const res = await axios.patch(
          '/api/v1/users/@me/item_sku_bookmarks/order',
          {
            user_item_sku_bookmarks: this.bookmarks
          }
        )
        if (res.data.saved) {
          this.backToBookmarkIndexPage()
        } else {
          this.hasValidationError = res.data.has_validation_error

          window.scrollTo({ top, behavior: 'smooth' })
          this.showableErrorFeedback = true
          this.feedbackErrorMessage = 'エラーが発生しました'
          this.isSubmitButtonDisable = false
        }
      } catch (error) {
        this.isSubmitButtonDisable = false
        this.showableErrorFeedback = true
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.feedbackErrorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.user-item-sku-bookmark-edit-order-page {
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__page-header-area {
    background: $white;
    height: 76px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__main-area {
    background: $white;
    margin-top: 16px;
  }

  &__main-content {
    max-width: $small-contents-width;
    margin: auto;
    padding-top: 32px;
  }

  &__box-list-area {
    text-align: left;
    padding: 0 16px;
    margin-bottom: 24px;
  }

  &__box-list {
    padding: 16px;

    li {
      @extend %minimal;
      color: $danger;
    }
  }

  &__caption-ul {
    padding: 0 16px 24px 32px;

    li {
      @extend %caption;
      list-style: disc;
      text-align: left;
    }
  }

  &__loading {
    padding-bottom: 16px;
  }

  &__submit-area {
    background-color: $white;
    border-top: 1px solid $gray-2;
    position: sticky;
    bottom: 0;
    z-index: 2; // BookmarkItemSkuForEditOrderの長押し時の「移動する」のカバーでz-index: 1を使用しているので、2を設定。
  }

  &__submit-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
    max-width: $small-contents-width;
    margin: auto;
    padding: 24px 16px;
  }

  &__cancel-button {
    border-color: $gray-1;
    color: $gray-1;
    width: 148px;
  }

  &__submit-button {
    width: 148px;
  }
}
</style>
